/** @format */

import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { actions as authActions } from "../../../../reducers/userReducer";
import { Form, Input, Button, message, Steps } from "antd";
import { isEmail } from "@/utils";

import {
  register as signUpAPI,
  sendVerificationCode as sendVerificationCodeAPI,
  checkAccount as checkAccountApi,
} from "../../../../Api/sign";

import "./index.less";

const FORM_NAME_TYPE = {
  email: "email",
  username: "username",
  password: "password",
  verificationCode: "verificationCode",
};

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0,
      email: "",
      username: "",
      password: "",
      verificationCode: "",
    };
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleEmailSubmit = this.handleEmailSubmit.bind(this);
    this.handleSignUpSubmit = this.handleSignUpSubmit.bind(this);
  }

  // 处理邮箱、密码、验证码的变化
  handleFormChange(e) {
    if (e.target.name === FORM_NAME_TYPE.email) {
      this.setState({
        username: e.target.value,
        email: e.target.value,
      });
    } else if (e.target.name === FORM_NAME_TYPE.password) {
      this.setState({
        password: e.target.value,
      });
    } else if (e.target.name === FORM_NAME_TYPE.verificationCode) {
      this.setState({
        verificationCode: e.target.value,
      });
    } else {
      // do nothing
    }
  }

  // 提交发送邮箱验证码
  async handleEmailSubmit(e) {
    e.preventDefault();
    const { email } = this.state;

    if (email.length === 0) {
      message.warning("Email cannot be empty!");
      return;
    }

    if (!isEmail(email)) {
      message.error("Please enter a valid email address.");
      return;
    }
    try {
      const checkAccountRes = await checkAccountApi({
        username: email,
      });

      if (checkAccountRes.code === 0) {
        const res = await sendVerificationCodeAPI({
          email,
          scene: "isSignUp",
        });

        if (res.code === 0) {
          this.setState({
            currentStep: 1,
          });
        } else {
          message.error(res.error.message || res.message);
        }
      } else {
        message.error(checkAccountRes.error.message || checkAccountRes.message);
      }
    } catch (err) {}
  }

  // 提交注册表单
  async handleSignUpSubmit(e) {
    e.preventDefault();
    const { email, username, password, verificationCode } = this.state;

    if (
      email.length === 0 ||
      username.length === 0 ||
      password.length === 0 ||
      verificationCode.length === 0
    ) {
      message.warning("Email & Password & Verification Code cannot be empty!");
      return;
    }

    const res = await signUpAPI({
      name: username,
      email,
      username,
      password,
      verificationCode,
    });
    if (res.code === 0) {
      this.props.login({
        userId: res.data.id,
        username: res.data.username,
        name: res.data.username,
        email: res.data.email,
        userImage: res.data.avatar,
        signature: res.data.signature,
      });
      this.props.loginSuccess({ message: "感谢您注册成为 LibRec Paper 成员" });
      this.setState({
        currentStep: 2,
      });
    } else {
      message.error(res.error.message || res.message);
    }
  }

  render() {
    const { currentStep } = this.state;
    const { Step } = Steps;

    return (
      <>
        <div className="form-container">
          {currentStep === 0 ? (
            <>
              <div className="title">Sign up with email</div>
              <div className="subtitle">
                Enter your email address to create an account, and we’ll send a
                verification code to your inbox.
              </div>
            </>
          ) : (
            <div className="steps-container">
              {/* // 注册步骤条 */}
              <Steps
                current={currentStep}
                size="small"
                percent={currentStep === 1 ? 40 : 100}
              >
                <Step title="Email" />
                <Step title="Verification Code" />
                <Step title="Enjoy" />
              </Steps>
            </div>
          )}

          <div className="email-container">
            {/* 发送邮箱验证码表单 */}
            {currentStep === 0 ? (
              <>
                <div className="email-span">Your email</div>
                <Form onSubmit={this.handleEmailSubmit}>
                  <Form.Item>
                    <Input
                      className={"email-input"}
                      bordered={false}
                      name={FORM_NAME_TYPE.email}
                      placeholder="Email"
                      value={this.state.username}
                      onChange={this.handleFormChange}
                    />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="continue-button"
                      onClick={this.handleEmailSubmit}
                    >
                      Continue
                    </Button>
                  </Form.Item>
                </Form>
              </>
            ) : null}

            {/* 发送 邮箱验证码，邮箱，密码 表单 */}
            {currentStep === 1 ? (
              <div>
                <Form onSubmit={this.handleSignUpSubmit}>
                  <Form.Item>
                    <Input
                      disabled
                      className={"email-input"}
                      bordered={false}
                      name={FORM_NAME_TYPE.email}
                      placeholder="Email"
                      value={this.state.username}
                      onChange={this.handleFormChange}
                    />
                  </Form.Item>
                  <Form.Item>
                    <Input
                      className={"email-input"}
                      bordered={false}
                      name={FORM_NAME_TYPE.password}
                      placeholder="Password"
                      value={this.state.password}
                      onChange={this.handleFormChange}
                    />
                  </Form.Item>
                  <Form.Item>
                    <Input
                      className={"email-input"}
                      bordered={false}
                      name={FORM_NAME_TYPE.verificationCode}
                      placeholder="Verification Code"
                      value={this.state.verificationCode}
                      onChange={this.handleFormChange}
                    />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="continue-button"
                      onClick={this.handleSignUpSubmit}
                    >
                      Sign Up
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            ) : null}

            {/* 完成注册 */}
            {currentStep === 2 ? (
              <div className="complete-text">Complete</div>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      login: authActions.login,
    },
    dispatch
  );

SignUp = connect(mapStateToProps, mapDispatchToProps)(SignUp);

export default SignUp;
